import { curryN } from "ramda";
import { updatePath } from "./updatePath.mjs";
export default curryN(3, (k, f, x) => updatePath([k], f, x));
//# sourceMappingURL=updateIn.mjs.map